function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.33332 10.6665H26.6667V27.9998C26.6667 28.3535 26.5262 28.6926 26.2761 28.9426C26.0261 29.1927 25.6869 29.3332 25.3333 29.3332H6.66666C6.31303 29.3332 5.9739 29.1927 5.72385 28.9426C5.4738 28.6926 5.33332 28.3535 5.33332 27.9998V10.6665ZM9.33332 6.6665V3.99984C9.33332 3.64622 9.4738 3.30708 9.72385 3.05703C9.9739 2.80698 10.313 2.6665 10.6667 2.6665H21.3333C21.6869 2.6665 22.0261 2.80698 22.2761 3.05703C22.5262 3.30708 22.6667 3.64622 22.6667 3.99984V6.6665H29.3333V9.33317H2.66666V6.6665H9.33332ZM12 5.33317V6.6665H20V5.33317H12ZM12 15.9998V23.9998H14.6667V15.9998H12ZM17.3333 15.9998V23.9998H20V15.9998H17.3333Z"
});

function SvgBin5Fill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin5Fill);
export default __webpack_public_path__ + "static/media/bin-5-fill.acbae5d4.svg";
export { ForwardRef as ReactComponent };